import reducer, { eventsTypes } from './duck';

export { History } from './containers';

export const historyModule = {
  reducer: reducer,
  eventsTypes: eventsTypes,
};
